import { Routes, Route, Link, useLocation } from 'react-router-dom';
import MapPage from './pages/MapPage';
import AdminPage from './pages/AdminPage';

function App() {
  const location = useLocation();

  return (
    <div className="app">
      <main className="main-content">
        <Routes>
          <Route path="/" element={<MapPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
